<template>
  <main id="shopslider">
    <agile :arrows="false" :speed="750"
           :timing="'linear'" :fade="true"
           :autoplay="false" :pauseOnHover="false">
      <div class="slide slide--1" v-bind:style="{height: pageHeight/2 + 'px'}">
          <parallax-container>
            <parallax-element :parallaxStrength="-5" :type="'translation'"
                              v-bind:style="(myWidth > 768) ? {'marginTop': + pageHeight/4 + 'px'} : {'marginTop': + (pageHeight/4-10) + 'px'}">
              <!--<img src="../../static/image/warningShop.png" style="display: block; margin: auto;">-->
              <h3 class="cit" style="color: white; position: relative; -webkit-animation: moving 15s infinite; animation: moving 15s infinite">{{$t('ship')}}</h3>
            </parallax-element>
          </parallax-container>
      </div>
      <div class="slide slide--2" v-bind:style="{height: pageHeight/2 + 'px'}"></div>
      <div class="slide slide--3" v-bind:style="{height: pageHeight/2 + 'px'}"></div>
      <div class="slide slide--4" v-bind:style="{height: pageHeight/2 + 'px'}"></div>
      <div class="slide slide--5" v-bind:style="{height: pageHeight/2 + 'px'}"></div>
    </agile>
  </main>
</template>

<script>
  export default {
    name: "ShopSlider",
    data() {
      return {
        pageHeight: 1000,
        scrittaCarousel: 800,
        myWidth: window.innerWidth
      }
    },
    i18n: {
      fallbackLocale: 'it', // default lang,
      messages: {
        it: {
          ship: 'Spedizione gratuita per spese superiori ai 450€, altrimenti 15€ per l\'Italia e 30€ per le altre nazioni'
        },
        en: {
          ship: 'Spedizione gratuita per spese superiori ai 450€, altrimenti 15€ per l\'Italia e 30€ per le altre nazioni'
        }
      }
    },
    updated: function () {
      window.addEventListener('resize', this.getPageHeight)
    },
    mounted: function () {
      window.addEventListener('resize', this.getPageHeight)
      this.getPageHeight()
    },
    methods: {
      getPageHeight: function (event) {
        this.pageHeight = window.innerHeight
        this.scrittaCarousel = this.pageHeight - 150
      }
    }
  }
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";

  :focus {
    outline: none !important;
  }

  #shopslider {
    z-index: 1;
    .agile {
      .agile__track{
        max-height: 410px;
      }
      .cit {
        //margin-top: 30%;
        text-align: center;
        .set-font-CardoItalic()
      }
      .autore {
        .set-font-title(@size: 37px);
      }
      .agile__dots {
        bottom: 0;
        left: 48%;
        position: absolute;
        width: 30px;
      }
      .agile__dot {
        padding: 2px;
        margin-bottom: 10px;
        button {
          background-color: transparent;
          border: 1px solid #fff;
          margin-top: 10px;

          &:hover {
            background-color: #fff;
          }
        }

        &.agile__dot--current {
          button {
            background-color: #fff;
          }
        }
      }
    }
    .slide {
      background-position: center;
      background-size: cover;
      &.slide--1 {
        background-image: url("../../static/image/shop.jpg");
      }
      &.slide--2 {
        background-image: url("../../static/image/2.jpg");
      }
      &.slide--3 {
        background-image: url("../../static/image/3.jpg");
      }
      &.slide--4 {
        background-image: url("../../static/image/4.jpg");
      }
      &.slide--5 {
        background-image: url("../../static/image/1.jpg");
      }
    }
  }

  @media (max-width: 767px) {
    #shopslider {
      .agile {
        .cit {
          //margin-top: 60%;
          .set-font-CardoItalic(@size: 22px)
        }
        .autore {
          padding-right: 20px;
          .set-font-title(@size: 25px);
        }
        .agile__dots {
          left: 40%;
          width: 100px;
        }
        .agile__dot {
          button {
          }

          &.agile__dot--current {
            button {
            }
          }
        }
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    .main {
      .agile {
        .cit {
          //margin-top: 70%;
          .set-font-CardoItalic()
        }
        .autore {
          padding-right: 20px;
          .set-font-title(@size: 37px);
        }
        .agile__dots {
        }
        .agile__dot {
          button {
          }

          &.agile__dot--current {
            button {
            }
          }
        }
      }
    }
  }

  @media (min-width: 1025px) and (max-width: 1366px) {
    .main {
      .agile {
        .cit {
          //margin-top: 70%;
          .set-font-CardoItalic()
        }
        .autore {
          padding-right: 20px;
          .set-font-title(@size: 37px);
        }
        .agile__dots {
        }
        .agile__dot {
          button {
          }

          &.agile__dot--current {
            button {
            }
          }
        }
      }
    }
  }
</style>
}
</script>

<
style
scoped >

< /style>



// WEBPACK FOOTER //
// src/components/ShopSlider.vue